import { render, staticRenderFns } from "./premium-tab.vue?vue&type=template&id=4899745b&scoped=true&"
import script from "./premium-tab.vue?vue&type=script&lang=js&"
export * from "./premium-tab.vue?vue&type=script&lang=js&"
import style0 from "./premium-tab.vue?vue&type=style&index=0&id=4899745b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4899745b",
  null
  
)

export default component.exports